import type {
  BlockUiSchema,
  JourneyContextValue,
  BlockVariablesHander
} from '@epilot/journey-logic-commons'
import {
  blockController,
  blockVariablesHandlerByBlock
} from '@epilot/journey-logic-commons'
import type { TFunction } from 'i18next'

type BlockWithHandlers = BlockUiSchema & {
  handler: BlockVariablesHander
  isExportingVariables: boolean
}

export function getVariablesData(
  context: JourneyContextValue,
  t: TFunction
): Record<string, unknown> | undefined {
  if (!context) return

  const steps = context.journey?.steps || []

  const blocksWithVariables = blockController
    .findBlocks(steps, { type: '*' })
    .map((block) => {
      const handlerConfig =
        block.controlNameId && blockVariablesHandlerByBlock[block.controlNameId]

      return {
        ...block.uischema,
        handler: handlerConfig?.handler,
        isExportingVariables: handlerConfig?.isExportingVariables
      } as BlockWithHandlers
    })
    .filter((blockWithHandlers) => blockWithHandlers.isExportingVariables)

  return blocksWithVariables.reduce((acc: Record<string, unknown>, block) => {
    const blockMetadata = context._journeySources?.find(
      ({ uischema }: { uischema: BlockUiSchema }) => uischema.id === block.id
    )

    const { stepIndex, key } = blockMetadata || {}

    if (stepIndex === undefined || key === undefined) {
      return acc
    }

    const stepStateHistory = context._stepsStateArray?.[stepIndex]
    const blockStateHistory = stepStateHistory?.[key]

    const blockData = block?.handler?.getValuesForExport?.({
      context,
      state: blockStateHistory, // Should be removed
      t
    })

    const path = block.options?.variablePath

    if (blockData && Object.keys(blockData).length) {
      if (path) {
        acc[path] = blockData
      } else {
        acc = {
          ...acc,
          ...blockData
        }
      }
    }

    return acc
  }, {})
}
